import React from 'react';
import ReactDOM, { Container } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { SENTRY_DSN, IS_PROD } from './config';
import './index.css';
import './amplifyConfig';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { AccountModeProvider } from './context/AccountModeContext';
import { ToastProvider } from './context/ToastContext';
import { WebSocketProvider } from './context/WebSocketContext';
import ToastContainer from './components/Toast/ToastContainer';

// ── Sentry error tracking ───────────────────────────────────
if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: IS_PROD ? 'production' : 'development',
    tracesSampleRate: IS_PROD ? 0.2 : 1.0,
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 0,
    ignoreErrors: ['ResizeObserver loop', 'Network request failed', 'Load failed', 'Failed to fetch', 'AbortError'],
  });
}

const root = ReactDOM.createRoot(document.getElementById('root') as Container);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <AccountModeProvider>
            <WebSocketProvider>
              <ToastProvider>
                <ErrorBoundary>
                  <App />
                </ErrorBoundary>
                <ToastContainer />
              </ToastProvider>
            </WebSocketProvider>
          </AccountModeProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
);

// Register the service worker for offline support & PWA install
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
